__turbopack_context__.v({
  "exploreButton": "features-module-scss-module__OrmWka__exploreButton",
});
